// 需要进行版本检测的路由路径
export const noticeUrlArr = [
  '/project-center/overview',  
  '/project-center/task',  
  '/project-center/send-order',  
  '/project-center/report/project-overview',  
  '/project-center/report/task',  
  '/project-center/report/recycle',  
  '/project-center/report/offline',  
  '/project-center/tool-task',  
  '/project-center/data/project-data',  
  '/project-center/data/tool-data',  
  '/project-center/data/origin',  
  '/project-center/my-favorite'
]